<template>
  <div class="w100 my-20 px-sm-10">
    <div class="row text-center">
      <div class="col-lg-6 col-md-6 col-sm-12">
        <div class="container-left-dashboard">
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12">
              <h1 class="font-white font-bold text-left">Mis resultados</h1>
              <hr class="separador-puntuaciones mb-3">
            </div>
            <div class="col-lg-6 col-md-6 d-sm-none dnone"></div>
          </div>
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12">
              <div v-for="(data, index) in filteredData" :key="index" class="row dashboard-score">
                <div class="col-6">
                  <p class="font-white font-regular text-score text-left mb-3">Mi posición</p>
                  <p class="scoreboard font-regular">{{ data.ranking }}</p>
                </div>
                <!-- <div class="col-5">
                <p class="font-white font-regular text-score mt-2 mb-3">Usuario</p>
                <p class="scoreboard font-regular">{{ data.name }}</p>
              </div> -->
                <div class="col-6">
                  <p class="font-white font-regular text-score text-left mb-3">Puntos</p>
                  <p class="scoreboard font-regular">{{ data.score }}</p>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12">
              <div class="mtmb-mobile">
                <button class="btn btn-primary btn-lg btn-launch-puntuaciones font-white"
                  @click="redirectWithTimeout('/predicciones-pilotos-max')">Predecir resultados</button>
              </div>
            </div>
          </div>
          <!-- Tabla de mejores 10 -->
          <h1 class="font-white text-left mb-3">Top 10</h1>
          <div class="container-top10">
            <div class="row dashboard-table-content">
              <div class="col-4 p-none">
                <p class="font-white font-regular">Posición</p>
              </div>
              <div class="col-4 p-none">
                <p class="font-white font-regular">Usuario</p>
              </div>
              <div class="col-4 p-none">
                <p class="font-white font-regular">Puntos</p>
              </div>
            </div>
            <div v-for="(data, index) in rankingData" :key="index" class="row dashboard-table-content">
              <div class="col-4 p-none">
                <p class="font-white score-boards ">{{ data.ranking }}</p>
              </div>
              <div class="col-4 p-none">
                <p class="font-white score-boards ">{{ data.name + ' ' + data.first_name.charAt(0) + '.' }}</p>
              </div>
              <div class="col-4 p-none">
                <p class="font-white score-boards ">{{ data.score }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-12 text-center">
        <img class="dashboard-pilotos" src="../../../assets/2026/pilotos.png" alt="PilotosRB">
        <div class="row dashboard-codigo mb-3 mt-5">
          <h3 class="font-white font-bold">¡Si encuentras el código secreto, puedes subir en el tablero!</h3>
          <p class="font-white font-regular">Descubre los códigos escondidos en blogs, canales y dinámicas, canjéalos y suma puntos para estar más de cerca de un premio exclusivo.</p>
          <div class="input-group">
            <input type="text" v-model="codigoRedimible"
              class="form-control font-white font-regular text-score text-left mb-3 input-codigo"
              placeholder="Escribe tu código" :disabled="enviandoCodigo">
            <button @click="redimirCodigo" :class="[
              'btn', 'btn-lg', 'font-white',
              (!codigoRedimible || enviandoCodigo) ? 'btn-redimible' : 'btn-primary btn-launch-puntuaciones left-20'
            ]" :disabled="!codigoRedimible || enviandoCodigo">
              {{ enviandoCodigo ? 'Enviando...' : 'Redimir' }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script src="./dashboard.js" />
<style src="./dashboard.scss" lang="scss" />
<script>
import axios from "axios";
import swal from "sweetalert2";

export default {
  name: 'dashboard',
  metaInfo: {
    title: 'Dashboard | Mobil Predictor ',
    meta: [
      { name: 'title', content: 'Dashboard | Mobil Predictor ' },
      { name: 'description', content: 'Controla tus estadísticas, posición en el ranking y ajusta tus pronósticos. Optimiza tu estrategia. ¡Escala posiciones junto a Max Verstappen y RBR!' }
    ]
  },
  data() {
    return {
      rankingData: [],
      filteredData: [],
      resultadosCarrera: {},
      codigoRedimible: '',
      enviandoCodigo: false
    };
  },
  mounted() {
    this.obtenerCarrera();
    this.fetchData();
    if (!localStorage.getItem('predictor')) {
      this.$router.push('/iniciar-sesion');
    }
    this.puntosPorCarrera();
  },
  methods: {
    fetchData() {
      axios
        // .get('https://www.mobilpredictor.com.mx/datos/api/ranking')
        // .get('http://127.0.0.1:8000/api/ranking')
        .get('https://api.mobilpredictor2025.vmtec.com.mx/api/ranking')
        .then((response) => {
          // Solo muestra los 10 primeros
          this.rankingData = response.data.filter(data => data.ranking !== null).sort((a, b) => a.ranking - b.ranking).slice(0, 10);

          const predictor = JSON.parse(localStorage.getItem('predictor'));
          const user = predictor.email;

          // Mostrar el puntaje de cada usuario
          this.filteredData = response.data.filter(data => data.email === user);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    puntosPorCarrera() {
      const predictor = JSON.parse(localStorage.getItem('predictor'));
      const email = predictor.email;

      // axios.post('https://www.mobilpredictor.com.mx/datos/api/puntuacionesCarrera', { email })
      // axios.post('http://127.0.0.1:8000/api/puntuacionesCarrera', { email })
      axios.post('https://api.mobilpredictor2025.vmtec.com.mx/api/puntuacionesCarrera', { email })
        .then((response) => {
          this.resultadosCarrera = response.data;
          console.log(this.resultadosCarrera);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    redirectWithTimeout(address) {
      setTimeout(() => {
        const countdownMs = 2 * 60 * 1000;
        localStorage.setItem('prediction_timer_started', String(Date.now()));
        localStorage.setItem('prediction_timer_deadline', String(Date.now() + countdownMs));
        window.location.href = address;
      }, 1500);
    },
    obtenerCarrera(){
      axios
      // .get('https://www.mobilpredictor.com.mx/datos/api/carreraActual')
      // .get('http://127.0.0.1:8000/api/carrera')
      .get('https://api.mobilpredictor2025.vmtec.com.mx/api/carreraActual')
      .then((response) => {
        const raceData = response.data;
        if(raceData.carrera === '0'){
          localStorage.setItem('gp', 0);
        }else{
          localStorage.setItem('gp', JSON.stringify(raceData.carrera));
        }
      })
      .catch((error) => {
        console.log(error);
      });
    },
    redimirCodigo() {
      if (!this.codigoRedimible.trim()) {
        swal.fire({
          title: 'Error',
          text: 'Por favor, ingresa un código válido',
          icon: 'error',
          confirmButtonText: 'Entendido'
        });
        return;
      }

      // Obtener el email desde localStorage
      let email = '';
      const predictor = localStorage.getItem('predictor');
      const login = localStorage.getItem('login');

      if (predictor) {
        const predictorData = JSON.parse(predictor);
        email = predictorData.email;
      } else if (login) {
        const loginData = JSON.parse(login);
        email = loginData.email;
      }

      if (!email) {
        swal.fire({
          title: 'Error',
          text: 'No se pudo obtener el email del usuario',
          icon: 'error',
          confirmButtonText: 'Entendido'
        });
        return;
      }

      this.enviandoCodigo = true;

      const payload = {
        code: this.codigoRedimible.trim(),
        email: email
      };

      axios
        // .post('https://www.mobilpredictor.com.mx/datos/api/promotion-codes/redeem', payload)
        // .post('http://127.0.0.1:8000/api/promotion-codes/redeem', payload)
        .post('https://api.mobilpredictor2025.vmtec.com.mx/api/promotion-codes/redeem', payload)
        .then((response) => {
          swal.fire({
            title: '¡Éxito!',
            text: 'Código redimido exitosamente',
            icon: 'success',
            confirmButtonText: 'Continuar',
            background: "rgba(0, 20, 79, 0.8)",
            confirmButtonColor: "#ff0000",
            color: "#fff",
          });
          this.codigoRedimible = '';

          // Opcional: Recargar los datos del ranking para mostrar los nuevos puntos
          this.fetchData();
        })
        .catch((error) => {
          let mensajeError = 'Error al redimir el código';

          if (error.response && error.response.data && error.response.data.message) {
            mensajeError = error.response.data.message;
          } else if (error.response && error.response.status === 404) {
            mensajeError = 'Código promocional inválido o ya ha sido utilizado';
          }

          swal.fire({
            title: 'Error',
            text: mensajeError,
            icon: 'error',
            confirmButtonText: 'Entendido',
            background: "rgba(0, 20, 79, 0.8)",
            confirmButtonColor: "#ff0000",
            color: "#fff",
          });
          console.log(error);
        })
        .finally(() => {
          this.enviandoCodigo = false;
        });
    }
  },
};
</script>
